// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","social":"Footer_social__iB1oi","links":"Footer_links__wMgLO","wrapper":"Footer_wrapper__T0psY"};